import React from "react";
import { Title } from "@components";
import locale from "@bonliva-crm/locale";

type Props = {
  onClose: () => void;
};

export const Success: React.FC<Props> = (props) => {
  return (
    <div>
      <Title style={{ textAlign: "center" }}>{locale.FileUploadSucceeded}</Title>
    </div>
  );
};
